/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: { borderColor: '#b2b9bf', borderStyle: 'solid', borderWidth: 1 }
}
export default theme
